import {
	BrokerContactCreationSubRole,
	PositionInTheCompanyChoice,
	SocietyUserVar,
} from "@dune/types";
import {
	Button,
	Chip,
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@dune/ui";
import { brokerUserCreationSubRolesLabels } from "@dune/vars";
import { ColumnDef } from "@tanstack/react-table";
import { DotsHorizontal } from "@untitled-ui/icons-react";

interface UserFromBrokerColumnsProps {
	onEdit: (user: SocietyUserVar) => void;
	onSuspend: (user: SocietyUserVar) => void;
	onSetManager: (user: SocietyUserVar) => void;
	canSetManager: boolean;
}

export const userFromBrokerColumns = ({
	onEdit,
	onSuspend,
	onSetManager,
	canSetManager,
}: UserFromBrokerColumnsProps): ColumnDef<SocietyUserVar>[] => [
	{
		accessorKey: "photo",
		header: "",
	},
	{
		accessorKey: "entity",
		header: "Entité",
	},
	{
		accessorKey: "lastname",
		header: "Nom",
	},
	{
		accessorKey: "firstname",
		header: "Prénom",
	},
	{
		accessorKey: "positionInTheCompany",
		header: "Fonction",
		cell: ({ row }) => {
			const position = row.original.positionInTheCompany;
			if (!position) return null;

			return (
				<Chip
					color="gray"
					label={PositionInTheCompanyChoice[position]}
					variant="bordered"
				/>
			);
		},
	},
	{
		accessorKey: "email",
		header: "Email",
	},
	{
		accessorKey: "landlinePhone",
		header: "Tel.",
	},
	{
		accessorKey: "mobilePhone",
		header: "Mobile",
	},
	{
		accessorKey: "profile",
		header: "Profile",
		cell: ({ row }) => {
			const subrole = row.original.subrole;
			if (!subrole) return null;

			const isBrokerSubrole = (
				role: string,
			): role is BrokerContactCreationSubRole =>
				role === "BROKER_ADMIN" || role === "BROKER_GESTIONNAIRE";

			if (!isBrokerSubrole(subrole)) return null;

			return (
				<Chip
					color="gray"
					label={brokerUserCreationSubRolesLabels[subrole]}
					variant="bordered"
				/>
			);
		},
	},
	{
		accessorKey: "status",
		header: "Statut",
		cell: ({ row }) => {
			return (
				<>
					{row.original.isActive && <Chip color="green" label="Actif" />}
					{!row.original.isActive && <Chip color="red" label="Inactif" />}
				</>
			);
		},
	},
	{
		accessorKey: "isSignatory",
		header: "Signataire",
		cell: ({ row }) => {
			return (
				<>
					{row.original.isSignatory && <Chip color="blue" label="Signataire" />}
				</>
			);
		},
	},
	{
		accessorKey: "actions",
		header: "",
		cell: ({ row }) => {
			return (
				<DropdownMenu>
					<DropdownMenuTrigger asChild>
						<Button variant="ghost" size="icon">
							<DotsHorizontal />
						</Button>
					</DropdownMenuTrigger>
					<DropdownMenuContent>
						<DropdownMenuItem onClick={() => onEdit(row.original)}>
							Modifier
						</DropdownMenuItem>
						<DropdownMenuItem onClick={() => onSuspend(row.original)}>
							{row.original.isActive ? "Suspendre" : "Réactiver"}
						</DropdownMenuItem>
						{canSetManager && (
							<>
								<DropdownMenuSeparator />
								<DropdownMenuItem onClick={() => onSetManager(row.original)}>
									{row.original.isSignatory
										? "Retirer signataire"
										: "Définir comme signataire"}
								</DropdownMenuItem>
							</>
						)}
					</DropdownMenuContent>
				</DropdownMenu>
			);
		},
	},
];
